module.exports = __webpack_public_path__ + "assets/road-bend-right-bottom.5817bea8.svg";